import React from "react";

export default function ModalConfirm({ open, setOpen, title, message, data, acceptCallback }) {
  const close = () => {
    setOpen(false);
  };

  const cancelButton = () => {
    setOpen(false);
  };
  const acceptButton = () => {
    setOpen(false);
    acceptCallback(data);
  };

  return (
    <div className="modalConfirm">
      <div className={`modal${open ? ' open' : ''}`}>
        <button className="close" onClick={() => close()}></button>
        <div className="modal-content">
          <h4>{title}</h4>
          <p className="message">{message}</p>
        </div>
        <div className="modal-footer">
          <div className="content-buttons">
            <a className="modal-close btn-flat" onClick={() => cancelButton()}>Cancelar</a>
            <a className="modal-close btn-flat buttonCustom" onClick={() => acceptButton()}>Aceptar</a>
          </div>
        </div>
      </div>
      <div className={`modal-overlay${open ? ' open' : ''}`} onClick={() => close()}></div>
    </div>
  );
}